import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

// 路由配置
const routes = [
    // 重定向
  {
    path: '/home',
    redirect: '/'
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue')
  },
]

// 创建 router 实例
const router = new VueRouter({
  mode: 'hash', // 默认 hash 模式
  base: process.env.BASE_URL,
  routes,
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router